import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import AdminNav from "@/components/AdminNav";
import { toast } from "sonner";

const KIND_LABELS = {
    confirmation_client: "Conferma cliente",
    notify_admin: "Notifica admin",
    reminder_24h: "Promemoria 24h",
    reminder_2h: "Promemoria 2h",
    move_client: "Spostamento cliente",
    cancel_client: "Annullamento cliente",
};

export default function AdminEmails() {
    const [emails, setEmails] = useState([]);
    const [open, setOpen] = useState({});

    useEffect(() => {
        api.get("/admin/emails").then((r) => setEmails(r.data)).catch((e) => toast.error(formatApiError(e)));
    }, []);

    return (
        <div className="min-h-screen bg-white">
            <AdminNav />
            <div className="max-w-4xl mx-auto px-4 py-6">
                <h2 className="text-xl font-bold mb-1">Registro Email</h2>
                <p className="text-xs text-gray-500 mb-4">Sistema email simulato — nessuna email viene realmente inviata. Le voci "scheduled" verranno marcate "sent" all'orario previsto.</p>
                <div className="border border-gray-200 divide-y divide-gray-200" data-testid="email-log">
                    {emails.length === 0 && <div className="p-4 text-sm text-gray-500">Nessuna email registrata.</div>}
                    {emails.map((e) => (
                        <div key={e.id} className="p-3 text-sm">
                            <div className="flex items-center justify-between gap-2 flex-wrap cursor-pointer" onClick={() => setOpen({ ...open, [e.id]: !open[e.id] })}>
                                <div className="flex items-center gap-2 flex-wrap">
                                    <span className={`text-xs px-2 py-0.5 border ${e.status === "sent" ? "border-green-300 bg-green-50 text-green-800" : "border-amber-300 bg-amber-50 text-amber-800"}`}>{e.status}</span>
                                    <span className="text-xs text-gray-500">{KIND_LABELS[e.kind] || e.kind}</span>
                                    <span className="font-semibold">{e.subject}</span>
                                </div>
                                <span className="text-xs text-gray-500">→ {e.to}</span>
                            </div>
                            {open[e.id] && (
                                <pre className="mt-2 whitespace-pre-wrap font-sans text-xs text-gray-700 border border-gray-200 bg-gray-50 p-3">{e.body}</pre>
                            )}
                            <div className="text-[11px] text-gray-400 mt-1">
                                Creata: {new Date(e.created_at).toLocaleString("it-IT")}
                                {e.scheduled_for && ` • Programmata: ${new Date(e.scheduled_for).toLocaleString("it-IT")}`}
                                {e.sent_at && ` • Inviata: ${new Date(e.sent_at).toLocaleString("it-IT")}`}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
